function getRoute() {
    let pages = getCurrentPages();
    let curPage = pages[pages.length - 1];
	if(!curPage) return {}
    let $route = null

    $route = curPage.$route




    return $route || {}
}

// 兼容各端的路由信息
export function createRouteMap(n = 1) {
    let $route = getRoute()
    return {
        fullPath: $route.fullPath,
        query: $route.query,
        path: $route.path
    }
}